import { render, staticRenderFns } from "./DadosAreaMonitorada.vue?vue&type=template&id=ecf253a8&scoped=true&lang=pug"
import script from "./DadosAreaMonitorada.vue?vue&type=script&lang=js"
export * from "./DadosAreaMonitorada.vue?vue&type=script&lang=js"
import style0 from "./DadosAreaMonitorada.vue?vue&type=style&index=0&id=ecf253a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf253a8",
  null
  
)

export default component.exports